<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <span>Ширина</span>
        <v-text-field
          outlined
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.inputWidth"
          :error-messages="errorMessages.width"
          @input="ChangingHandler($event, 'Width', 'input')"
        />
      </v-col>
      <v-col cols="6">
        <span>Ед. измерения</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.valueWidth"
          :items="$options.valueTypesCSSList"
          @change="ChangingHandler($event, 'Width', 'value')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Высота</span>
        <v-text-field
          outlined
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.inputHeight"
          :error-messages="errorMessages.height"
          @input="ChangingHandler($event, 'Height', 'input')"
        />
      </v-col>
      <v-col cols="6">
        <span>Ед. измерения</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.valueHeight"
          :items="$options.valueTypesCSSList"
          @change="ChangingHandler($event, 'Height', 'value')"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-divider />
    </v-row>
    <v-row no-gutters class="mt-5 mb-10">
      <v-col>
        <span>Список: ({{ listItem.data.slides.length }})</span>
        <ErrorMessage :message="errorMessages.slides" />
      </v-col>
      <v-spacer />
      <v-btn
        class="mr-2"
        small
        :disabled="isLoading"
        :loading="isLoading"
        @click="mixAddListItemItemHandler('slides', $options.widgetItems)"
      >
        <v-icon small> mdi-plus </v-icon>
      </v-btn>
    </v-row>
    <v-row
      align="center"
      class="mb-5"
      v-for="(listItemItem, listItemItemIndex) in listItem.data.slides"
      :key="listItemItemIndex"
    >
      <v-card max-width="100%" flat color="transparent">
        <v-card-title>
          <v-row align="center" justify="space-between">
            <span> Слайд {{ listItemItemIndex + 1 }}: </span>
            <v-btn
              class="mr-2"
              small
              :disabled="isLoading"
              :loading="isLoading"
              @click="mixRemoveListItemItemHandler(listItemItemIndex, 'slides')"
            >
              <v-icon color="red">mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-col cols="6">
              <v-row no-gutters align="center">
                <MediaFilePicker
                  :multiple="false"
                  :label="'Медиа файл'"
                  :isShowCaption="true"
                  :caption="listItemItem.data.caption"
                  :file-type="$options.mediaTypesByKeys.IMAGE"
                  :value="listItemItem.data.image"
                  @change="
                    mixUploadImageHandler($event, 'slides', 'image', listItemItemIndex)
                  "
                  @change-caption="
                    mixChangeListItemItemHandler(
                      $event,
                      'slides',
                      listItemItemIndex,
                      'caption'
                    )
                  "
                >
                  <template #preview-bottom>
                    <ErrorMessage
                      :message="
                        errorMessages[listItemItemIndex]
                          ? errorMessages[listItemItemIndex].image
                          : ''
                      "
                    />
                  </template>
                </MediaFilePicker>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span>Заполнение изображения</span>
              <v-select
                outlined
                item-value="value"
                item-text="title"
                return-object
                hide-details
                dense
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.fit"
                :items="$options.imageFits"
                @change="
                  mixChangeListItemItemHandler($event, 'slides', listItemItemIndex, 'fit')
                "
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider />
          </v-row>
          <v-row>
            <v-col cols="12">
              <span>Заголовок (<TranslationIcon />)</span>
              <v-text-field
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.title"
                @input="
                  mixChangeListItemItemHandler(
                    $event,
                    'slides',
                    listItemItemIndex,
                    'title'
                  )
                "
              />
            </v-col>
          </v-row>
          <v-row>
            <QuillEditorVue
              :cols="12"
              :content="listItemItem.data.description"
              :loading="isLoading"
              :disabled="isLoading"
              light-mode
              @input="
                mixChangeListItemItemHandler(
                  $event,
                  'slides',
                  listItemItemIndex,
                  'description'
                )
              "
              @onChangeContent="mixChangeListItemHandler($event, 'descriptionForMobile')"
            />
          </v-row>
          <v-row>
            <v-divider />
          </v-row>
          <v-row>
            <v-col cols="6">
              <span>Заголовок кнопки (<TranslationIcon />)</span>
              <v-text-field
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.buttonTitle"
                @input="
                  mixChangeListItemItemHandler(
                    $event,
                    'slides',
                    listItemItemIndex,
                    'buttonTitle'
                  )
                "
              />
            </v-col>
            <v-col cols="6">
              <span>Ссылка кнопки</span>
              <v-text-field
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.buttonLink"
                @input="
                  mixChangeListItemItemHandler(
                    $event,
                    'slides',
                    listItemItemIndex,
                    'buttonLink'
                  )
                "
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'

import imageFits from '@/configs/imageFits'
import { widgetItems } from '@/utils/widgets/widgetsTypes.js'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import valueTypesCSSList from '@/configs/valueTypesCSS'

import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker.vue'
import ErrorMessage from '@/components/error-messages/ErrorMessage'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import QuillEditorVue from '@/components/quill-editor'
const regex = /(px|em|%|in|pt+)$/gim

export default {
  name: 'GalleryWidget',
  mediaTypesByKeys: mediaTypesByKeys(),
  widgetItems,
  valueTypesCSSList,
  mixins: [dynamicListItemMix],
  imageFits,
  components: {
    TranslationIcon,
    ErrorMessage,
    MediaFilePicker,
    QuillEditorVue
  },
  data () {
    return {
      fields: {
        valueWidth: null,
        valueHeight: null,
        inputWidth: null,
        inputHeight: null
      }
    }
  },
  computed: {
    returnWidth () {
      return this?.listItem?.data?.width.toString() || null
    },
    returnHight () {
      return this?.listItem?.data?.height.toString() || null
    }
  },
  methods: {
    populateSize (field) {
      switch (field) {
        case 'width':
          this.fields.inputWidth = this.returnWidth?.replace(regex, '')
          this.fields.valueWidth = this.returnWidth?.slice(
            this.returnWidth?.search(regex)
          )
          break
        case 'height':
          this.fields.inputHeight = this.returnHight?.replace(regex, '')
          if (this.returnHight?.match(regex)) {
            this.fields.valueHeight = this.returnHight?.slice(
              this.returnHight?.search(regex)
            )
          } else {
            this.fields.valueHeight = 'px'
          }
          break
        default:
          break
      }
      this.inputWidth = this.returnWidth?.replace(regex, '')
      const idxWidth = this.returnWidth?.search(regex)
      this.valueWidth = this.returnWidth?.slice(idxWidth)
    },
    ChangingHandler (payload, field = 'Width', typeSize = 'input') {
      const stateField = `${typeSize}${field}`
      this.fields[stateField] = payload
      this.mixChangeListItemHandler(
        String(this.fields[`input${field}`] + this.fields[`value${field}`]).trim(),
        field.toLowerCase()
      )
    }
  },
  mounted () {
    this.populateSize('width')
    this.populateSize('height')
  }
}
</script>
